import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import {PointofsaleService} from '../api/pointofsale/pointofsale.service';
import {CurrencyService} from '../manage/currency/currency.service';
import {ToolsService} from '../tools/tools.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class GuardCurrencyService implements CanActivate {

  constructor(
    private posApi: PointofsaleService,
    private currencyMng: CurrencyService,
    private router: Router,
    private tools: ToolsService,
    public translate: TranslateService
  ) {
  }

  canActivate(
    next: ActivatedRouteSnapshot | any,
    state: RouterStateSnapshot): Promise<any> {

    const that = this;

    return new Promise(resolve => {

      if (next.params.merchantId || next.params.webshopId) {

        const keyRequest = next.params.merchantId ?
          this.posApi.$_getUserKeyByMerchantId(next.params.merchantId) :
          this.posApi.$_getUserKeyByWebShopId(next.params.webshopId, "guardCurrency")

        keyRequest.then((data: any) => {


          // Si il n'y a pas de reponse..
          if (Array.isArray(data.object)) {

            this.router.navigate(["/404", this.translate.instant('error404.nokey') + (next.params.merchantId ? this.translate.instant('error404.merchant') : this.translate.instant('error404.pof'))], {skipLocationChange: true});
          }

          // enregistre  les infos si change d'etablissement et veut recuperer la commande
          let old_order_other_etablishment: any = {
            id_merchant: this.tools.getStor("id_merchant") ? this.tools.getStor("id_merchant") : data.object.id_merchant,
            url_encode: this.tools.getStor("url_encode") ? this.tools.getStor("url_encode") : data.object.url_encode,
            id_webshop: this.tools.getStor("point_of_sale") ? this.tools.getStor("point_of_sale").id_webshop : data.object.id_webshop
          }

          this.tools.setStor("old_order_other_etablishment", old_order_other_etablishment);


          //on set id_merchant
          this.tools.setStor("id_merchant", data.object.id_merchant);


          let par: any = next.params.merchantId ? next.params.merchantId : null
          if (data && data.object && data.object.id_merchant) {
            par = data.object.id_merchant
          }


          if (next.params.webshopId || data.object.point_of_sale) {

            this.tools.setStor("point_of_sale", data.object.point_of_sale);

          }

          that.posApi.$_getUserAccount(par).then(data => {


            // id_webshop
            // url_encode
            this.tools.setStor("url_encode", data.object.url_encode);
            this.tools.setStor("id_merchant", data.object.id_webshop);

            next.queryParams = {user: data.object};
            that.currencyMng.setCurrCurrency(data.object.currency);


            resolve(true);

          }).catch(function (error) {
            console.error('error:', error)

            resolve(true);
          });


        })

      } else {

        const pointOfSale = that.tools.getStor("point_of_sale");

        if (pointOfSale) {

          that.posApi.$_getUserAccount().then(data => {


            //on set id_merchant
            that.tools.setStor("id_merchant", data.object.id_webshop);

            that.currencyMng.setCurrCurrency(data.object.currency);


            resolve(true);

          }).catch(function (error) {
            console.error('error:', error)

            resolve(true);

          });
        }

        resolve(true);
      }
    });
  }
}
